import { useEffect } from 'react';
import pinterest from '@app/external/common/services/pinterest';
import { useSelector } from '../components/runtime-context';
import { getIsMobile, getLanguage } from '../store/basic-params/basic-params-selectors';
import { usePostPageShareProviders } from './use-post-page-share-providers';

export function usePinterestInit() {
  const language = useSelector(getLanguage);
  const isMobile = useSelector(getIsMobile);
  const { isPluginPinterestEnabled } = usePostPageShareProviders();

  useEffect(() => {
    pinterest.init({ language, isMobile, isPinterestEnabled: isPluginPinterestEnabled });

    return () => {
      pinterest.removeEventListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
